(function () {
    'use strict';

    angular
        .module('loyalty')
        .controller('LoyaltyProgramItemEditController', LoyaltyProgramItemEditController);

    LoyaltyProgramItemEditController.$inject = ['LoyaltyService', '$uibModalInstance','item'];

    function LoyaltyProgramItemEditController(LoyaltyService, $uibModalInstance, item) {

        var vm = this;

        vm.ok = ok;
        vm.cancel = cancel;
        vm.serviceStatus = [{id : 1, name : 'Yes'}, {id : 0, name : 'No'}];
        vm.activate = activate;
        vm.item = [];
        vm.newImage = false;

        function activate() {
            angular.copy(item, vm.item);
            vm.item.points = parseInt(vm.item.points);
            if(vm.item.active === 1)
                vm.item.active = {id : 1, name : 'Yes'};
            else
                vm.item.active = {id : 0, name : 'No'};
        }
        // vm.programItems = programItems;

        function ok () {
            vm.fd = new FormData();
            vm.fd.append('description', vm.item.description);
            vm.fd.append('points', vm.item.points);
            vm.fd.append('active', vm.item.active.id);
            if(vm.newImage){
                vm.fd.append('image', vm.newImage);
            }
            vm.fd.append('id', vm.item.id);
            LoyaltyService.updateProgramItem(vm.fd).then(function(response) {
                if(!response.data.error) {
                    item.description = response.data.item.description;
                    item.active = response.data.item.active;
                    item.points = parseInt(response.data.item.points);
                    item.image = response.data.item.image;
                    item.image_url = response.data.item.image_url;
                    alertify.notify(response.data.message, 'success', 3);
                    $uibModalInstance.close();
                }
                else{
                    alertify.notify(response.data.message, 'error', 3);
                    $uibModalInstance.close();
                }
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }

        vm.activate();
    }

})();